import { ActionIcon, Tooltip } from '@mantine/core';
import { IconSparkles2Filled, IconSparkles2Off } from '@tabler/icons-react';
import { useLocation } from 'wouter';
import { paths } from '../../app/routes';
import { useAccount } from '../account/AccountProvider';

/**
 * Flow toolbar: are automatic argument titles running on this device, and if not, why.
 * Tapping it when they're off goes to Settings to sign in.
 */
export const AiTitleStatus = () => {
  const { state } = useAccount();
  const [, navigate] = useLocation();
  if (state.status === 'disabled') return null;
  const online = navigator.onLine;
  const on = state.status === 'signedIn' && !!state.user && !state.problem && online;
  const why = on
    ? 'Automatic titles are on: each argument gets a short title about 2 seconds after you finish writing it.'
    : !online
      ? 'Automatic titles are off: this device is offline.'
      : state.status === 'loading'
        ? 'Automatic titles: connecting…'
        : state.status === 'unavailable'
          ? "Automatic titles are off: can't reach sign-in on this device."
          : state.status === 'signedIn'
            ? `Automatic titles are off: ${state.problem ?? 'checking your account…'}`
            : 'Automatic titles are off: sign in on this device (tap to open Settings).';
  return (
    <Tooltip label={why} multiline w={260}>
      <ActionIcon
        variant={on ? 'light' : 'subtle'}
        color={on ? undefined : 'gray'}
        onMouseDown={(e) => e.preventDefault()}
        onClick={() => !on && navigate(paths.settings('account'))}
        aria-label={why}
        data-testid="ai-title-status"
        data-on={on ? '1' : '0'}
      >
        {on ? <IconSparkles2Filled size={16} /> : <IconSparkles2Off size={16} />}
      </ActionIcon>
    </Tooltip>
  );
};
